<template>
  <div >
      <v-card>
        <v-card-title style="background-color: rgb(21, 101, 192); color: white;">
          ข้อมูลการจบงาน
        </v-card-title>

        <v-card-text>
          <br />
          <h3>เลขที่จบงาน : {{this.closeJobNo}} </h3>
          ระบบได้ทำบันทึกข้อมูลการจบงาน {{this.trnCount}} รายการ
          <br />จากใบแจ้งหนี้ ตั้งแต่เวลา {{this.rankDate}}
          <br />ยอดรวม {{this.trnTotal}} บาท
          <br />ยอดตั้งเบิก {{this.trnGrandTotal}} บาท
          <br />ยอดจ่ายจริง {{this.trnActualReceipts}} บาท
           <br /><span class="green--text">เรียบร้อยแล้ว!!</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="close"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
  </div>
</template>

<script>
import numeral from 'numeral'
export default {
  name: 'popupCloseJob',
   data: () => ({
      closeJobNo:'',
    trnCount:0,
    rankDate:'',
    trnTotal:0.00,
    trnGrandTotal:0.00,
    trnActualReceipts:0.00
   }),
  methods: {
        setData(item,trnActualReceipts){
            this.closeJobNo = item.closeJobNo;
            this.trnCount = item.trnCount;
            this.rankDate = item.rankDate;
            this.trnTotal = numeral(item.trnTotal).format('0,0.00');
            this.trnGrandTotal = numeral(item.trnGrandTotal).format('0,0.00');
            this.trnActualReceipts = numeral(trnActualReceipts).format('0,0.00');
        },
        close() {
           this.$emit("clickCloseJob");
        }
  }
   

}
</script>